import React, { ChangeEvent } from 'react'
import { isEmpty, without } from 'lodash'
import { Trans } from '@lingui/macro'
import {
  Box,
  Checkbox,
  MenuBulkAction,
  HStack,
  MenuItem
} from 'front-end/src/components'
import { brandColors } from 'front-end/../shared/basicPalette'
import { radii } from 'front-end/src/components/chakraThemeExtension'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'
import { UserGroupRoleEnum } from 'types/UserGroup'

export const UsersBatchActions: React.FC<{
  selectedUserIds: number[]
  toggleAllUsersSelection?: (value: boolean) => void
  onGroupRoleChange: (role: UserGroupRoleEnum, userIds: number[]) => void
  onArchiveUsers: (userIds: number[]) => void
  onRemoveUsersFromGroup: (userIds: number[]) => void
  usersCount: number
}> = (props) => {
  const { session } = usePublicApiSession()

  const onCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked
    props.toggleAllUsersSelection && props.toggleAllUsersSelection(value)
  }

  const isAnySelected = () => {
    return !isEmpty(props.selectedUserIds)
  }

  const isEveryUserSelected = () => {
    return (
      props.selectedUserIds.length === props.usersCount &&
      props.selectedUserIds.length > 0
    )
  }

  const isIndeterminateState = () => {
    return (
      !isEmpty(props.selectedUserIds) &&
      props.selectedUserIds.length < props.usersCount
    )
  }

  const getSelectedIds = (includeSelf = false): number[] => {
    if (includeSelf) {
      return props.selectedUserIds
    }
    return without(props.selectedUserIds, session?.user.id as number)
  }

  const setGroupRole = (role: UserGroupRoleEnum) => {
    const target = getSelectedIds()
    props.onGroupRoleChange && props.onGroupRoleChange(role, target)
  }

  return (
    <HStack spacing="16px">
      <Box>
        <Checkbox
          verticalAlign="text-bottom"
          borderRadius={radii.sm}
          backgroundColor={brandColors.white}
          isChecked={isEveryUserSelected()}
          isIndeterminate={isIndeterminateState()}
          onChange={onCheckboxChange}
        />
      </Box>
      <MenuBulkAction isDisabled={!isAnySelected()}>
        <MenuItem onClick={() => setGroupRole(UserGroupRoleEnum.ADMIN)}>
          <Trans>Change group role to Administrator</Trans>
        </MenuItem>
        <MenuItem onClick={() => setGroupRole(UserGroupRoleEnum.MEMBER)}>
          <Trans>Change group role to Member</Trans>
        </MenuItem>
        <MenuItem
          onClick={() => {
            const target = getSelectedIds()
            props.onRemoveUsersFromGroup && props.onRemoveUsersFromGroup(target)
          }}
        >
          <Trans>Remove users from this group</Trans>
        </MenuItem>
        <MenuItem
          onClick={() => {
            const target = getSelectedIds(false)
            props.onArchiveUsers && props.onArchiveUsers(target)
          }}
        >
          <Trans>Archive</Trans>
        </MenuItem>
      </MenuBulkAction>
    </HStack>
  )
}
